
namespace TabAurous.ProductDevelopment {


    @Serenity.Decorators.registerClass()
    export class CustomerRequirementGrid extends _Ext.GridBase<CustomerRequirementRow, any> {
        protected getColumnsKey() { return 'ProductDevelopment.CustomerRequirement'; }
        protected getDialogType() { return CustomerRequirementDialog; }
        protected getIdProperty() { return CustomerRequirementRow.idProperty; }
        protected getInsertPermission() { return CustomerRequirementRow.insertPermission; }
        protected getLocalTextPrefix() { return CustomerRequirementRow.localTextPrefix; }
        protected getService() { return CustomerRequirementService.baseUrl; }
        //private rowSelection: Serenity.GridRowSelectionMixin;
        private autoSize;
        constructor(container: JQuery) {
            super(container);
            this.slickGrid.setOptions({ rowHeight: 30 });
        }
        protected onClick(e: JQueryEventObject, row: number, cell: number) {
            var item = this.itemAt(row);
           // CustomerRequirementItemsEditor.baseitemcheck = item.BaseItemTypeId;
            super.onClick(e, row, cell);
        }
        protected addButtonClick() {

            let now = new Date();
            var voucherNo = FormatHelper.GetVoucherNo(101);
            var userDefinition = Q.Authorization.userDefinition;
            this.editItem(<CustomerRequirementRow>{
                VoucherNo: voucherNo,
                Line_No: 0,
                VoucherTypeId: 101,
                CompanyId: userDefinition.CompanyId,
                FinancialYearId: userDefinition.FinancialYearId,
                UserId: userDefinition.UserId,
                CurrencyId: userDefinition.CurrencyId,
                TransDate: now.toDateString()
            });
        }
        protected createSlickGrid(): Slick.Grid {
            let grid = super.createSlickGrid();
            this.autoSize = new Slick.AutoColumnSize();
            grid.registerPlugin(this.autoSize);


            return grid;
        }
        protected createToolbarExtensions() {
            super.createToolbarExtensions();
            this.rowSelection = new Serenity.GridRowSelectionMixin(this);
        }


        protected markupReady() {
            super.markupReady();
            if (this.autoSize != null) {
                this.autoSize.resizeAllColumns();
            }
        }
    }
}